import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Error from './views/Error.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*/error',
      name: 'error',
      component: Error
    },
    {
      path: '*/vipRule',
      name: 'vipRule',
      component: () => import("@/views/VipRule.vue")
    },
    {
      path: '/*',
      name: 'home',
      component: Home
    }
  ]
})
